export const arcadiaCommunityOfficeHoursURL =
  'https://community.arcadia.io/office-hours';

export const communityOfficeHoursURL =
  'https://dataverse.carejourney.com/community-office-hours';
